// AUTO-GENERATED - DO NOT EDIT MANUALLY

import {
  OnboardChangePasswordDto,
  OnboardLoginDto,
  OnboardRegisterDto,
  RestorePasswordDto,
  TotpCodeDto,
  IBaseSingleResultDto,
} from '@skillarea/lib-shared';

import { IRequestOptions, IRequestConfig, getConfigs, axios } from './options';

export const basePath = '';

export class OnboardService {
  /**
   * POST /api/user/login
   */
  signIn(
    params: {
      /** requestBody */
      body?: OnboardLoginDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/login';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * POST /api/user/logout
   */
  signOut(options: IRequestOptions = {}): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/logout';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * POST /api/user/2fa/totp/setup
   */
  setupTotp(
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/2fa/totp/setup';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * PUT /api/user/2fa/totp/enable
   */
  enableTotp(
    params: {
      /** requestBody */
      body?: TotpCodeDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/2fa/totp/enable';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * PUT /api/user/2fa/totp/disable
   */
  disableTotp(
    params: {
      /** requestBody */
      body?: TotpCodeDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/2fa/totp/disable';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * POST /api/user/mfa/totp/verify
   */
  verifyTotp(
    params: {
      /** requestBody */
      body?: TotpCodeDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/mfa/totp/verify';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * POST /api/user/register
   */
  register(
    params: {
      /** requestBody */
      body?: OnboardRegisterDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/register';

      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * PUT /api/user/restore-password
   */
  restorePassword(
    params: {
      /** requestBody */
      body?: RestorePasswordDto;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/restore-password';

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * GET /api/user/change-password/:link
   */
  checkChangePasswordLink(
    params: {
      /** link */
      link: string;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/change-password/{link}';
      url = url.replace('{link}', params['link'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * PUT /api/user/change-password/:link
   */
  changePassword(
    params: {
      /** requestBody */
      body?: OnboardChangePasswordDto;
      /** link */
      link: string;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/change-password/{link}';
      url = url.replace('{link}', params['link'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options,
      );

      let data = params.body;
      configs.data = data;

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * PUT /api/user/activate/:linkActivation
   */
  confirmLinkActivation(
    params: {
      /** linkActivation */
      linkActivation: string;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/activate/{linkActivation}';
      url = url.replace('{linkActivation}', params['linkActivation'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * GET /api/user/check-link-activation/:email
   */
  checkLinkActivation(
    params: {
      /** email */
      email: string;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/check-link-activation/{email}';
      url = url.replace('{email}', params['email'] + '');

      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }

  /**
   * PUT /api/user/resend-link-activation/:email
   */
  resendLinkActivation(
    params: {
      /** email */
      email: string;
    },
    options: IRequestOptions = {},
  ): Promise<IBaseSingleResultDto<void>> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/api/user/resend-link-activation/{email}';
      url = url.replace('{email}', params['email'] + '');

      const configs: IRequestConfig = getConfigs(
        'put',
        'application/json',
        url,
        options,
      );

      axios(configs, (response: any) => resolve(response), reject);
    });
  }
}
